import PropTypes from "prop-types";
import FulfilmentChangeNotification from "../FulfilmentChangeNotification";
import FulfilmentLabel from "../FulfilmentLabel";

const Fulfilment = ({ source, seller, ...rest }) => (
  <>
    <FulfilmentChangeNotification source={source} seller={seller} />
    <FulfilmentLabel seller={seller} source={source} {...rest} />
  </>
);

Fulfilment.propTypes = {
  source: PropTypes.shape({
    description: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  }),
  seller: PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })
};

export default Fulfilment;
